import React from 'react';
import { useTranslation } from 'react-i18next';
import { ScrollView, StyleSheet, View } from 'react-native';
import ShowMoreAccordian from 'shared/components/ShowMoreAccordian/ShowMoreAccordion';
import HairLineDivider from 'shared/components/vxl/divider/HairlineDivider/HairLineDivider';
import ListItem from 'shared/components/vxl/ListItem/ListItem';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import { VXLComponentId } from 'shared/renderer/types';
import theme from 'shared/styles/theme';

const COMBINED_DISCLOSURE_MAX_LENGTH = 164;

const MakeCreditBuildingContent = () => {
  const { t: translatedText } = useTranslation('believe');

  return (
    <ScrollView contentContainerStyle={styles.scrollContainer}>
      <View style={styles.bodyWrapper}>
        <BodyBaseText style={styles.bodyText}>
          {translatedText('application.makeCreditBuilding.varoBelieveCardText')}
        </BodyBaseText>
        <View>
          <ListItem
            primaryCopy={translatedText(
              'application.makeCreditBuilding.noFeesText',
            )}
            showsChevron={false}
            leadingAccessory={{
              id: 'noFeesIcon',
              name: VXLComponentId.ICON_AVATAR,
              props: {
                iconKey: 'NO_FEES',
                iconSize: 'MD',
              },
            }}
          />
          <View style={styles.hairLineDivider}>
            <HairLineDivider />
          </View>
          <ListItem
            primaryCopy={translatedText(
              'application.makeCreditBuilding.creditScoreText',
            )}
            showsChevron={false}
            leadingAccessory={{
              id: 'creditScoreIcon',
              name: VXLComponentId.ICON_AVATAR,
              props: {
                iconKey: 'CREDIT_SCORE',
                iconSize: 'MD',
              },
            }}
          />
          <View style={styles.hairLineDivider}>
            <HairLineDivider />
          </View>
          <ListItem
            primaryCopy={translatedText(
              'application.makeCreditBuilding.thumbText',
            )}
            primaryNumberOfLines={0}
            showsChevron={false}
            leadingAccessory={{
              id: 'thumbsUpIcon',
              name: VXLComponentId.ICON_AVATAR,
              props: {
                iconKey: 'THUMBS_UP',
                iconSize: 'MD',
              },
            }}
          />
        </View>
        <View style={styles.parentContainer}>
          <ShowMoreAccordian
            text={translatedText('application.makeCreditBuilding.disclosure')}
            maxLength={COMBINED_DISCLOSURE_MAX_LENGTH}
          />
        </View>
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  bodyText: {
    textAlign: 'center',
    paddingHorizontal: theme.spacing.m,
  },
  bodyWrapper: {
    flex: 1,
    gap: theme.spacing.m,
    paddingVertical: theme.spacing.m,
  },
  hairLineDivider: { paddingHorizontal: theme.spacing.m },
  parentContainer: {
    gap: theme.spacing.s,
    paddingBottom: theme.spacing.m,
    paddingHorizontal: theme.spacing.m,
  },
  scrollContainer: {
    backgroundColor: theme.color.background.primary,
    flexGrow: 1,
  },
});

export default MakeCreditBuildingContent;
